














































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { NetworkSecurityInternetGeneralInformationData } from '@/modules/tickets/requirement/network-security-internet/domain/network-security-internet-general-information';
import { LinkManagementData } from '@/modules/tickets/incidents/link-management/domain/link-management-data';

@Component({
    name: 'link-management-ticket-confirmation',
})
export default class LinkManagementTicketConfirmation extends Vue {
    @Prop({ required: true })
    generalInformation!: LinkManagementData;

    private isFormValid: boolean = true;

    private isCreatingTicket: boolean = false;

    sendRequirementTicket() {
        this.$emit('sendRequirementTicket');
    }

    previousStep() {
        this.$emit('previousStep');
    }

    reset() {
        this.$emit('reset');
    }
}
